import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// autogenerated boilerplate code for merging classes safely with tailwind for shadcn/ui
// DO NOT MODIFY
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
